import api from '../../services/api';
import { AUTH_ACTIONS } from '../types/actionTypes';

export const loginUser = (credentials) => async (dispatch) => {
  dispatch({ type: AUTH_ACTIONS.LOGIN_REQUEST });
  
  try {
    const response = await api.post('/auth/login', credentials);
    const { token } = response.data;
    
    localStorage.setItem('token', token);
    
    dispatch({
      type: AUTH_ACTIONS.LOGIN_SUCCESS,
      payload: { token }
    });
    
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Login failed';
    dispatch({
      type: AUTH_ACTIONS.LOGIN_FAILURE,
      payload: message
    });
    throw error;
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem('token');
  dispatch({ type: AUTH_ACTIONS.LOGOUT });
}; 